import React, { Component } from 'react';
import { uniqueId } from 'lodash';
import autoBind from 'auto-bind';
export default class CheckBox extends Component {
	constructor(props) {
		super(props);
		autoBind(this);
		this.state = {
			id: uniqueId('Checkbox'),
			isChecked: this.props.initialChecked,
			label: this.props.label
		};
	}

	onChange(event) {
		let isChecked = event.currentTarget.checked;
		this.setState({ isChecked });
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.isChecked !== this.state.isChecked &&
			typeof this.props.onChange === 'function'
		) {
			this.props.onChange(this.state.isChecked);
		}
	}

	render() {
		let imgUrlPV = ''
		let imgUrlAV = ''
		if (this.state.label == 'Publish Video') {
			if (this.state.isChecked) {
				imgUrlPV = require("../../../images/images/video_call.png")

			} else {
				imgUrlPV = require("../../../images/images/video_none.png")
			}
		}

		if (this.state.label == 'Publish Audio') {
			if (this.state.isChecked) {
				imgUrlAV = require("../../../images/images/audio_call.png")

			} else {
				imgUrlAV = require("../../../images/images/audio_none.png")
			}
		}
		return (
			<div>
				<label htmlFor={this.state.id}>
					{this.state.label == 'Publish Video' ? <img src={imgUrlPV} /> : <img src={imgUrlAV} />}
					{/* {this.props.label} */}
				</label>
				<input
					type="checkbox"
					checked={this.state.isChecked}
					id={this.state.id}
					onChange={this.onChange}
					style={{ 'display': 'none' }}
				/>
			</div>
		);
	}
}
